// extracted by mini-css-extract-plugin
export var productImage = "_wy-0";